<script>

export default {
    name: 'AntenModal',
    props:[
        "data",
        "modelOpen"
    ],
    data() {
        return {
            form: {},
            chartData: {
                series: [],
                chartoptions: {
                    chart: {
                        height: 350,
                        type: 'area',
                        toolbar: {
                            show: false
                        },
                        zoom: {
                            enabled: false
                        },
                        animations: {
                            enabled: true,
                            easing: 'linear',
                            dynamicAnimation: {
                                speed: 1000
                            }
                        },
                    },
                    colors: ["#556ee6", "#f1b44c"],
                    dataLabels: {
                        enabled: false,
                    },
                    stroke: {
                        curve: "smooth"
                    },
                    
                    xaxis: {
                        categories: [],
                    },
                    markers: {
                        size: 0,
                    },
                    legend: {
                        position: "top",
                        horizontalAlign: "right",
                    },
                },
            },
            ping:{},
            interface:{},
            resource:{},
            monitor:{},
            registration:{},
            dhcp:{},
            wireless:{},
            arp:{},
            lease:{},
            txData:[],
            rxData:[],
            timeData:[],
            submitted: false,
            intervalId: null,
        };
    }, 
    watch:{
        modelOpen(){
            let antenCount = 0;
            this.form = {...this.data}
            this.getApt()
            this.intervalId = setInterval(() => {

                antenCount = antenCount + 1

                if(antenCount > 20 ) return 

                const now = new Date();
                var hour = now.getHours();
                var minute = now.getMinutes();
                var second = now.getSeconds();

                // Saat, dakika ve saniye değerlerini çift hane olarak düzenle
                hour = hour < 10 ? '0' + hour : hour;
                minute = minute < 10 ? '0' + minute : minute;
                second = second < 10 ? '0' + second : second;

                this.$http.post('/anten', { framedipaddress:this.form.framedipaddress })
                        .then(response => {
                            if(this.txData.length > 10 ){
                                this.txData.shift()
                            }
                            if(this.rxData.length > 10 ){
                                this.rxData.shift()
                            }
                            if(this.timeData.length > 10 ){
                                this.timeData.shift()
                            }
                            const download = ((parseInt(response.data[0]) / 1024 ) /1024).toFixed(2)
                            const upload = ((parseInt(response.data[1]) / 1024 ) /1024).toFixed(2)
                            

                            this.txData.push(download)
                            this.rxData.push(upload)
                            this.timeData.push(`${hour}:${minute}:${second}`)
                        })
                this.chartData= {
                            series: [
                                {
                                    name: "Download",
                                    data:  this.txData,
                                },
                                {
                                    name: "Upload",
                                    data: this.rxData,
                                },
                            ],
                            chartoptions:{
                                xaxis: {
                                    categories:this.timeData,
                                },
                            }
                        }
            }, 2000);
        }
    },
    computed:{
        time(){
            return  this.resource.hasOwnProperty('uptime') ? this.resource.uptime.replace('d', ' Gün, ')
                        .replace('h', ' Saat, ')
                        .replace('m', ' Dakika, ')
                        .replace('s', ' Saniye')
                        .replace('w', ' Hafta, ') : '-'
        },
    },
    mounted(){
    },
    methods: {
        prettyDate(){
            const now = new Date();

            const hoursAndMinutes = now.getHours() + ':' + now.getMinutes();
            return hoursAndMinutes
        },  
        getApt(){
            this.$http.post('/anten/getAll', { framedipaddress:this.form.framedipaddress })
                        .then(response => {
                            this.interface = response.data.interface
                            this.resource = response.data.resource
                            this.monitor = response.data.monitor
                            this.dhcp = response.data.dhcp
                            this.wireless = response.data.wireless
                            this.arp = response.data.arp
                            this.lease = response.data.lease
                            this.registration = response.data.registration
                        })
        },
        getPing(){
            this.$http.post('/anten/getPing', { framedipaddress:this.form.framedipaddress })
                        .then(response => {
                            this.ping = response.data
                        })
        },
        close(){
            clearInterval(this.intervalId);
            this.$parent.$bvModal.hide('apt_modal')
        }
    },
    beforeDestroy() {
        clearInterval(this.intervalId);
    },
};
</script>

<template>
<b-modal id="anten_modal" size="xl" title="Anten"  no-close-on-backdrop hide-footer>
    <template #modal-header="{ close }" >
        <b-button size="sm" class="float-right" variant="outline-danger" @click="close()">
            Kapat
        </b-button>
    </template>
    <div class="row">
        <div class="col-md-6 col-sm-12 col-xs-12 mb-3">
            <div class="table-responsive">
                <table class="table">
                    <thead class="table-light">
                        <tr>
                            <th colspan=2>Müşteri Cihaz Bilgileri</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>Model</th>
                            <td>{{ resource['board-name'] }}</td>
                        </tr>
                        <tr>
                            <th>Versiyon </th>
                            <td>{{ resource.version }}</td>
                        </tr>
                            <tr>
                            <th>Çalışma Süresi</th>
                            <td>{{ time }}</td>
                        </tr>
                    </tbody>
                    <thead class="table-light">
                        <tr>
                            <th colspan=2>Ethernet Durumu</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>Bağlantı Durumu</th>
                            <td>
                                <span class="badge bg-success" style="font-size:14px" v-if="monitor.status == 'link-ok'">Kablo Takılı</span>
                                <span class="badge bg-danger" style="font-size:14px" v-else-if="monitor.status == 'no-link'">Kablo Takılı Değil</span>
                                <span v-else>{{ monitor.status }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th>Bağlantı Hızı </th>
                            <td>{{ monitor.rate }}</td>
                        </tr>
                        <tr>
                            <th>Modem Resetli </th>
                            <td>
                                <span v-if='dhcp.status !=  "bound"'>DHCP YOK</span>
                                <span v-else class="text-danger"><strong>DHCP VAR</strong></span>
                            </td>
                        </tr>
                        <tr>
                            <th>Dağıtılan İp</th>
                            <td><span class="text-danger"><strong>{{ dhcp.address }}</strong></span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12 mb-3">
            <div class="table-responsive">
                <table class="table">
                    <thead class="table-light">
                        <tr>
                            <th colspan=2>Abone Wifi Bilgileri</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>MAC</th>
                            <td>{{ wireless["mac-address"] }}</td>
                        </tr>
                        <tr>
                            <th>Bağlı Olduğu Verici</th>
                            <td>{{ wireless.ssid  }}</td>
                        </tr>
                            <tr>
                            <th>RADIO NAME</th>
                            <td>{{ wireless["radio-name"] }}</td>
                        </tr>
                    </tbody>
                    <thead class="table-light">
                        <tr>
                            <th colspan=2>Sinyal Bilgileri</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>Sinyal Gücü TX / RX</th>
                            <td>
                                <div class="row">
                                    <div class="col-md-6 text-center">
                                        {{ registration["tx-signal-strength"] * -1 }} 
                                        <BProgress class="animated-progess progress-sm">
                                        <BProgressBar 
                                            :variant="registration['tx-signal-strength']* -1 < 60 ? 'success' : registration['tx-signal-strength']* -1 < 70 ? 'warning' : 'danger' " 
                                            role="progressbar" 
                                            :style="`width: ${registration['tx-signal-strength'] * -1}%`" :aria-valuenow="registration['tx-signal-strength']* -1" 
                                            aria-valuemin="0" 
                                            aria-valuemax="100"
                                        >
                                        </BProgressBar>
                                        </BProgress>
                                    </div>
                                    <div class="col-md-6 text-center">
                                        {{ registration["signal-strength"] * -1 }}
                                        <BProgress class="animated-progess progress-sm">
                                        <BProgressBar 
                                            :variant="registration['signal-strength'] * -1 <= 60 ? 'success' : registration['signal-strength'] * -1 < 70 ? 'warning' : 'danger' " 
                                            role="progressbar" 
                                            :style="`width: ${registration['signal-strength'] * -1}%`" :aria-valuenow="registration['signal-strength'] * -1" 
                                            aria-valuemin="0" 
                                            aria-valuemax="100"
                                        >
                                        </BProgressBar>
                                        </BProgress>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>CH0 Sinyal Gücü TX / RX</th>
                            <td>
                                <div class="row">
                                    <div class="col-md-6 text-center">
                                        {{ registration["tx-signal-strength-ch0"] * -1 }} 
                                        <BProgress class="animated-progess progress-sm">
                                        <BProgressBar 
                                            :variant="registration['tx-signal-strength-ch0']* -1 < 60 ? 'success' : registration['tx-signal-strength-ch0']* -1 < 70 ? 'warning' : 'danger' " 
                                            role="progressbar" 
                                            :style="`width: ${registration['tx-signal-strength-ch0'] * -1}%`" :aria-valuenow="registration['tx-signal-strength-ch0']* -1" 
                                            aria-valuemin="0" 
                                            aria-valuemax="100"
                                        >
                                        </BProgressBar>
                                        </BProgress>
                                    </div>
                                    <div class="col-md-6 text-center">
                                        {{ registration["signal-strength-ch0"] * -1 }}
                                        <BProgress class="animated-progess progress-sm">
                                        <BProgressBar 
                                            :variant="registration['signal-strength-ch0'] * -1 <= 60 ? 'success' : registration['signal-strength-ch0'] * -1 < 70 ? 'warning' : 'danger' " 
                                            role="progressbar" 
                                            :style="`width: ${registration['signal-strength-ch0'] * -1}%`" :aria-valuenow="registration['signal-strength-ch0'] * -1" 
                                            aria-valuemin="0" 
                                            aria-valuemax="100"
                                        >
                                        </BProgressBar>
                                        </BProgress>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>CH1 Sinyal Gücü TX / RX</th>
                            <td>
                                <div class="row">
                                    <div class="col-md-6 text-center">
                                        {{ registration["tx-signal-strength-ch1"] * -1 }} 
                                        <BProgress class="animated-progess progress-sm">
                                        <BProgressBar 
                                            :variant="registration['tx-signal-strength-ch1']* -1 < 60 ? 'success' : registration['tx-signal-strength-ch1']* -1 < 70 ? 'warning' : 'danger' " 
                                            role="progressbar" 
                                            :style="`width: ${registration['tx-signal-strength-ch1'] * -1}%`" :aria-valuenow="registration['tx-signal-strength-ch1']* -1" 
                                            aria-valuemin="0" 
                                            aria-valuemax="100"
                                        >
                                        </BProgressBar>
                                        </BProgress>
                                    </div>
                                    <div class="col-md-6 text-center">
                                        {{ registration["signal-strength-ch1"] * -1 }}
                                        <BProgress class="animated-progess progress-sm">
                                        <BProgressBar 
                                            :variant="registration['signal-strength-ch1'] * -1 <= 60 ? 'success' : registration['signal-strength-ch1'] * -1 < 70 ? 'warning' : 'danger' " 
                                            role="progressbar" 
                                            :style="`width: ${registration['signal-strength-ch1'] * -1}%`" :aria-valuenow="registration['signal-strength-ch1'] * -1" 
                                            aria-valuemin="0" 
                                            aria-valuemax="100"
                                        >
                                        </BProgressBar>
                                        </BProgress>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>CCQ (Sinyal Kalitesi)</th>
                            <td>
                                <div class="row">
                                    <div class="col-md-6 text-center">
                                        {{ registration["tx-ccq"] }} 
                                        <BProgress class="animated-progess progress-sm">
                                        <BProgressBar 
                                            :variant="registration['tx-ccq']  <= 55 ? 'danger' : registration['tx-ccq'] < 65 ? 'warning' : 'success' " 
                                            role="progressbar" 
                                            :style="`width: ${registration['tx-ccq']}%`" :aria-valuenow="registration['tx-ccq']" 
                                            aria-valuemin="0" 
                                            aria-valuemax="100"
                                        >
                                        </BProgressBar>
                                        </BProgress>
                                    </div>
                                    <div class="col-md-6 text-center">
                                        {{ registration["rx-ccq"]  }}
                                        <BProgress class="animated-progess progress-sm">
                                        <BProgressBar 
                                            :variant="registration['rx-ccq']  <= 55 ? 'danger' : registration['rx-ccq'] < 65 ? 'warning' : 'success' " 
                                            role="progressbar" 
                                            :style="`width: ${registration['rx-ccq']}%`" :aria-valuenow="registration['rx-ccq']" 
                                            aria-valuemin="0" 
                                            aria-valuemax="100"
                                        >
                                        </BProgressBar>
                                        </BProgress>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-8 mb-3">
            <apexchart
            class="apex-charts"
            dir="ltr"
            height="350"
            :series="chartData.series"
            :options="chartData.chartoptions"
            ></apexchart>
        </div>
        <div class="col-md-4 mb-3 text-center">
            <b-button 
                @click="getPing"
                type="submit" 
                variant="success" 
                class="ms-1"
                >{{ ping.output ? 'Tekrar Ping At' : 'Ping At' }}
            </b-button>
            <table class="table mt-3" v-if="ping.output">
                <thead class="table-light">
                    <tr>
                        <th>İp</th>
                        <th>Time</th>
                        <th>Packet Loss</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(png,i) in ping.output" :key="i">
                        <td>{{ png.ip }}</td>
                        <td>{{ png.time }}</td>
                        <td>{{ png['packet-loss'] }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan=3 class="text-center">
                            Ortalama {{ ping.average }} ms
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <div class="d-flex justify-content-between mt-3">
        <b-button 
            type="submit" 
            variant="success" 
            class="ms-1"
            >Arıza Kaydı Aç
        </b-button>

        
    </div>
</b-modal>
</template>